import { Body, FlexBox } from '@Backlot-Cars/archie';
import { Value } from './styles';

export const AuctionAccessAccountDetail = ({ label, value }) => (
	<FlexBox flexDirection="column" gap="xxs">
		<Body color="secondary" size="smaller">
			{label}
		</Body>
		{value && <Value bold>{value}</Value>}
	</FlexBox>
);
